import angular from "angular"
import "ngVue"
import "ngVue/build/plugins.js"

// Setup Vue
import Vue from "vue"
import VueApollo from "vue-apollo"

// Setup Apollo
import apolloClient from "./client"

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

// Setup moment
import moment from "moment"

moment.updateLocale("es", {
  relativeTime: {
    future: "en %s",
    past: "hace %s",
    s: "unos segundos",
    ss: "%d segundos",
    m: "un minuto",
    mm: "%d minutos",
    h: "una hora",
    hh: "%d horas",
    d: "un día",
    dd: "%d días",
    M: "un mes",
    MM: "%d meses",
    y: "un año",
    yy: "%d años"
  }
})

// These all export the module name
import ngAnimateModuleName from "angular-animate"
import ngAriaModuleName from "angular-aria"
// import ngCookiesModuleName from 'angular-cookies';
import ngMaterialModuleName from "angular-material"
import ngMessagesModuleName from "angular-messages"
import ngRouteModuleName from "angular-route"
import ngResourceModuleName from "angular-resource"
// import ngSanitizeModuleName from 'angular-sanitize';
// import ngTouchModuleName from 'angular-touch';

import ngFocusIfModuleName from "ng-focus-if"
import ngDatatablesModuleName from "angular-datatables"
import ngUiRouterModuleName from "@uirouter/angularjs"

import { permission, uiPermission } from "angular-permission"
import ngAngularStorageModuleName from "angular-storage"
import ngAngularJWTModuleName from "angular-jwt"

import "angular-material-event-calendar"

import Chart from "chart.js"

import "angular-chart.js"

const ngDatatablesLightFilter = require("./static/js/datatables-light-columnfilter/angular-datatables.light-columnfilter.js")

/* modules */
import fichaAlumnoModuleName from "./modules/ficha-alumno"

import routing from "./routing"

const dependencies = [
  "ngVue",
  "ngVue.plugins",
  ngAnimateModuleName,
  ngAriaModuleName,
  ngMaterialModuleName,
  ngMessagesModuleName,
  ngRouteModuleName,
  ngFocusIfModuleName,
  ngDatatablesModuleName,
  ngDatatablesLightFilter,
  ngUiRouterModuleName,
  permission,
  uiPermission,
  ngAngularStorageModuleName,
  ngAngularJWTModuleName,
  ngResourceModuleName,
  "material.components.eventCalendar",
  "chart.js",
  fichaAlumnoModuleName,
  "angular-google-analytics"
]

const config = [
  "$mdDateLocaleProvider",
  "$resourceProvider",
  "ChartJsProvider",
  "AnalyticsProvider",
  function($mdDateLocaleProvider, $resourceProvider, ChartJsProvider, AnalyticsProvider) {
    // Example of a Spanish localization.
    $mdDateLocaleProvider.months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ]
    $mdDateLocaleProvider.shortMonths = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ]
    $mdDateLocaleProvider.days = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ]
    $mdDateLocaleProvider.shortDays = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"]
    // Can change week display to start on Monday.
    $mdDateLocaleProvider.firstDayOfWeek = 1
    // Optional.
    //$mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, 7,8,9,10,11,12,13,14,15,16,17,18,19,
    //                               20,21,22,23,24,25,26,27,28,29,30,31];
    // In addition to date display, date components also need localized messages
    // for aria-labels for screen-reader users.
    $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
      return "Semana " + weekNumber
    }
    $mdDateLocaleProvider.msgCalendar = "Calendario"
    $mdDateLocaleProvider.msgOpenCalendar = "Abrir calendario"

    $resourceProvider.defaults.stripTrailingSlashes = false
    $resourceProvider.defaults.actions.update = {
      method: "PATCH"
    }

    // Configure ChartJS
    var colors = ["#FF0000", "#00FF00", "#0000FF", "#FF0000", "#FF0000", "#FF0000", "#FF0000"]
    ChartJsProvider.setOptions({
      colors: colors
    })
    Chart.defaults.global.colors = colors

    // Dashboard pie chart plugin
    var plugin = {
      id: "p1",
      beforeDraw: function(chart) {
        var plugin_options = chart.chart.options.plugins.p1 || {}
        if (!plugin_options.enabled) {
          return
        }

        var data = chart.data.datasets[0].data

        var count = 0
        var total = 0

        // All but the last item
        for (var i = 0; i < data.length - 1; i++) {
          count += data[i]
        }

        // All items
        for (var i = 0; i < data.length; i++) {
          total += data[i]
        }

        // Calculate percentage
        if (total == 0) {
          var percentage = 0
        } else {
          var percentage = 100.0 * (count / total)
        }

        var text = percentage.toFixed() + "%"
        var text_height_scale = plugin_options.text_height_scale || 60
        var text_color = plugin_options.text_color || "#6c6d72"

        var width = chart.chart.width,
          height = chart.chart.height,
          ctx = chart.chart.ctx

        ctx.restore()
        var fontSize = (height / text_height_scale).toFixed(2)
        ctx.font = fontSize + "em sans-serif"
        ctx.textBaseline = "middle"
        ctx.fillStyle = text_color

        var textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2

        ctx.fillText(text, textX, textY)
        ctx.save()
      }
    }

    Chart.plugins.register(plugin)

    // Define a plugin to provide data labels
    Chart.plugins.register({
      id: "p2",
      afterDatasetsDraw: function(chart) {
        var plugin_options = chart.chart.options.plugins.p2 || {}
        if (!plugin_options.enabled) {
          return
        }

        var ctx = chart.ctx

        chart.data.datasets.forEach(function(dataset, i) {
          var meta = chart.getDatasetMeta(i)
          if (!meta.hidden) {
            meta.data.forEach(function(element, index) {
              // Draw the text in white, with the specified font
              ctx.fillStyle = "rgb(255, 255, 255)"

              var fontSize = 32
              var fontStyle = "normal"
              var fontFamily = "sans-serif"
              ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

              // Just naively convert to string for now
              var dataString = dataset.data[index].toString()

              dataString = dataString + "%"

              // Make sure alignment settings are correct
              ctx.textAlign = "left"
              ctx.textBaseline = "middle"

              var padding = -16
              var position = element.tooltipPosition()
              ctx.fillText(dataString, position.x / 2.5, position.y - fontSize / 2 - padding)
            })
          }
        })
      }
    })
    AnalyticsProvider.setAccount(window.TRACK_ID_ANALYTICS)
    if (!window.TRACK_ANALYTICS) {
      AnalyticsProvider.disableAnalytics(true)
    }
  }
]

const run = [
  "PermPermissionStore",
  "PermRoleStore",
  "permissionService",
  "Analytics",
  "$transitions",
  "$location",
  function(
    PermPermissionStore,
    PermRoleStore,
    permissionService,
    Analytics,
    $transitions,
    $location
  ) {
    $transitions.onSuccess({}, function(transition) {
      Analytics.trackPage($location.path())
    })
    PermPermissionStore.definePermission("descargarReportes", function() {
      return permissionService.descargarReportes()
    })
    PermPermissionStore.definePermission("mantenedorUsuarios", function() {
      return permissionService.mantenedorUsuarios()
    })
    PermPermissionStore.definePermission("mantenedorAtenciones", function() {
      return permissionService.mantenedorAtenciones()
    })
    PermPermissionStore.definePermission("eliminarAtenciones", function() {
      return permissionService.eliminarAtenciones()
    })
    PermPermissionStore.definePermission("eliminarAlertas", function() {
      return permissionService.eliminarAlertas()
    })
    PermPermissionStore.definePermission("eliminarComentarios", function() {
      return permissionService.eliminarComentarios()
    })
    PermPermissionStore.definePermission("editarSoloAtencionesMasivas", function() {
      return permissionService.editarSoloAtencionesMasivas()
    })
    PermPermissionStore.definePermission("isResponsible", function() {
      return permissionService.hasSpecificRole("RESPONSABLE")
    })
    PermPermissionStore.definePermission("escribirComentariosPrivados", function() {
      return permissionService.escribirComentariosPrivados()
    })
    PermPermissionStore.definePermission("app_edit_enrollment_state", function() {
      return permissionService.editEnrollmentState()
    })
    PermPermissionStore.definePermission("app_download_user_permissions_report", function() {
      return permissionService.downloadUserPermissionsReport()
    })

    PermRoleStore.defineRole("ADMINISTRADOR", [
      "descargarReportes",
      "mantenedorUsuarios",
      "mantenedorAtenciones",
      "eliminarAtenciones",
      "eliminarAlertas",
      "eliminarComentarios"
    ])
    PermRoleStore.defineRole("DAE", [
      "descargarReportes",
      "eliminarAtenciones",
      "eliminarAlertas",
      "eliminarComentarios"
    ])

    PermRoleStore.defineRole("RESPONSABLE", ["isResponsible"])
    PermRoleStore.defineRole("EDITOR ATENCIONES MASIVAS", ["editarSoloAtencionesMasivas"])
    $transitions.onSuccess({}, function(transition) {
      Analytics.trackPage($location.path())
    })
  }
]

const apolloConfig = [
  "$ngVueProvider",
  function($ngVueProvider) {
    $ngVueProvider.setRootVueInstanceProps({
      apolloProvider: apolloProvider
    })
  }
]

var app = angular
  .module("appModule", dependencies)
  .config(config)
  .config(routing)
  .config(apolloConfig)
  .run(run)

export default app
